import {Component, AfterViewInit, ElementRef, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {JhiEventManager} from 'ng-jhipster';

import {LoginService} from '@core/login/login.service';
import {StateStorageService} from '@core/auth/state-storage.service';
import {AuthService} from '@core/auth/auth.service';
import {Principal} from '@app/core';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '@core/language.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements AfterViewInit, OnDestroy {
  data = {
    password: '',
    username: '',
  };
  credentials: any;
  hide = true;
  constructor(
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private elementRef: ElementRef,
    private eventManager: JhiEventManager,
    private principal: Principal,
    private authService: AuthService,
    private router: Router,
    private titleService: Title,
    private translate: TranslateService,
  ) {
    this.credentials = {};
  }

  private langSub?: Subscription;

  ngAfterViewInit() {
    // set initial title
    this.titleService.setTitle(this.translate.instant('login.Đăng nhập_title'));
    // update title when language changes
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(
        this.translate.instant('login.Đăng nhập_title'),
      );
    });
  }

  ngOnDestroy(): void {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  login() {
    this.loginService
      .login({
        username: this.data.username,
        password: this.data.password,
        rememberMe: true,
      })
      .then(() => {
        const url = '/dashboard';
        if (url) {
          this.stateStorageService.storeUrl(null);
        }
        this.router.navigateByUrl(url, {
          replaceUrl: true,
        });

        this.eventManager.broadcast({
          name: 'authenticationSuccess',
          content: 'Sending Authentication Success',
        });
      })
      .catch(() => {});
  }
}
